module.exports = __webpack_public_path__ + "static/media/program-v1.4ef09f72.png";